/**
* company.helper.ts
*/
export class CompanyHelper {

  public static calculateTrialDays(trialStartDate: Date, trialDurationDays: number): { daysRemaining: number, expired: boolean } {
    const startDate = new Date(trialStartDate);
    const expirationDate = new Date(startDate);
    expirationDate.setDate(expirationDate.getDate() + trialDurationDays);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    expirationDate.setHours(0, 0, 0, 0);

    const diffTime = expirationDate.getTime() - today.getTime();
    const daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const expired = daysRemaining < 0;

    return {
      daysRemaining,
      expired
    };
  }

}